import React, { useState, useEffect } from 'react'
import './Login.scss'
import md5 from 'md5';
import axios from 'axios'
import Cookies from 'js-cookie';
import { connect } from 'react-redux'
import * as _ from 'lodash'
import { useNavigate } from "react-router-dom"
import { infoUser } from '../hooks/user';
import { setUserActive } from '../actions'
import { tokerUser } from '../hooks/user';
import moment from 'moment';
import { UserIconLogin, UserPassLogin } from '../utils/icons';
import { DobleGuion } from '../components/DobleGuion'
import { showPopup, showSpinner } from '../actions/index'
import { comprobarDatos } from '../hooks/validateForm';
import { API,APIS } from '../hooks/config';

const Login = (props) => {
  const navigate = useNavigate();

    const { userActive, clickChangeRegistrationLogin } = props
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    useEffect(() => {
        // Desactivar el spinner cuando el componente se haya montado
        props.showSpinner(false);
    }, []);
    const reglas = {
        email: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            email: { message: 'con un formato invalido' },
        },
        password: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        }
    };

    useEffect(() => {
        if (!_.isEmpty(userActive)) {
            navigate(-1)
        }
    }, [props.userActive])

    const handleClickAccess = () => {
        const datos = {
            email: email.toLowerCase(),
            password: password
        }
        const alias = {
            password: 'contraseña'
        }
        comprobarDatos(datos, reglas, alias).then(res => {
            props.showSpinner(true)
            console.log('email new log', email);
            console.log('APIS[]', APIS['fansa']);
            axios.defaults.withCredentials = true;
            axios.interceptors.response.use(
                (response) => {
                   
                    const cookie = response.headers['set-cookie'] || [];
                   
                    cookie.forEach((cookieItem) => {
                        if (cookieItem.includes('fansa_token')) {
                            const token = cookieItem.split('=')[1].split(';')[0]; // Obtienes el valor del token
                            Cookies.set('fansa_token', token); // Asegúrate de que la cookie se guarde
                        }
                    });
                    return response;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            
            axios.post(`${APIS['fansa']}/login`, { email: email.toLowerCase(), password: md5(password) }).then(async res => {
                if (res.status === 200 && res.data === 'login ok') {
                    await infoUser().then(respuesta => {
                        props.showSpinner(false)
                        if (respuesta !== undefined) {
                            props.showPopup({ active: true, message: 'Sessión iniciada', type: 'success' })
                            props.setUserActive(respuesta)
                            handleClickSaveLogAccess(respuesta)
                        }
                    }).catch(err => {
                        console.log(err);
                        props.showSpinner(false)
                        props.showPopup({ active: true, message: 'Acceso no permitido', type: 'error' })
                    });
                }
            }).catch(err => {
                props.showSpinner(false)
                props.showPopup({ active: true, message: 'Acceso no permitido', type: 'error' })
            });
        }).catch(err => {
            props.showPopup({ active: true, message: err, type: 'error' })
        })
    }


    const handleClickSaveLogAccess = (user) => {
        tokerUser().then(res => {
            const tokenUser = res
            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${tokenUser}`
                }
            };
            const date = moment().format('DD/MM/YYYY HH:mm');
            axios.post(`${API}/protected/log-login`, { email: user.email, dateFecha: date, platform: 'web' }, headers).then(res => {
                console.log('res11 protected', res);
            }).catch(err => {
                console.log('err', err);
            });
        })
    }

    return (
        <div className="login-component-container">
            <div className="header">
                <div className="data">
                    <p>Acerca las plantas a tu entorno </p>
                    <DobleGuion />
                </div>
            </div>
            <div className="login-component-content">
                <div className="titulo">
                    <p>Iniciar sesion</p>
                </div>
                <div className="form-login">
                    <div className="input-block email">
                        <label htmlFor="email">Email</label>
                        <div className="input">
                            <input type="text" onChange={event => setEmail(event.target.value)} value={email} />
                            <UserIconLogin size={20} />
                        </div>
                    </div>
                    <div className="input-block pass">
                        <label htmlFor="pass">Contraseña</label>
                        <div className="input">
                            <input type="password" onChange={event => setPassword(event.target.value)} value={password} />
                            <UserPassLogin size={20} />
                        </div>
                    </div>
                </div>
                <div className="buttons">
                    <div className="boton">
                        <button className="btn btn-invert" onClick={handleClickAccess}>Acceder</button>
                    </div>
                    <div className="reset-pass">
                        <p>{/*/* eslint-disable jsx-a11y/anchor-is-valid */  }
                            <a className="pointer" onClick={() => clickChangeRegistrationLogin('reset')}>¿Olvidaste la contraseña?</a></p>
                    </div>
                </div>
                <div className="go-registration">
                    <p>¿No eres usuario?</p>
                    <button className="btn btn-invert" onClick={() => clickChangeRegistrationLogin('registration')}>Registrate ahora</button>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    setUserActive,
    showPopup,
    showSpinner
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(Login)
